import styled from 'styled-components';

export const OuterWrapper = styled.div<{ maxWidth?: number | string }>`
  max-width: ${({ maxWidth }) => maxWidth || 'auto'};
  width: 100%;
  flex-shrink: 0;
`;

export const AspectRatioMain = styled.div<{ ratio: number }>`
  padding-bottom: ${({ ratio }) => `${(1 / ratio) * 100}%`};
  position: relative;
  width: 100%;
`;

export const AspectRatioInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
`;
import styled from 'styled-components';

export const OuterWrapper = styled.div<{ maxWidth?: number | string }>`
  max-width: ${({ maxWidth }) => maxWidth || 'auto'};
  width: 100%;
  flex-shrink: 0;
`;

export const AspectRatioMain = styled.div<{ ratio: number }>`
  padding-bottom: ${({ ratio }) => `${(1 / ratio) * 100}%`};
  position: relative;
  width: 100%;
`;

export const AspectRatioInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
`;
